import { useEffect } from 'react';
import type { UserContext } from '@/types/user-context';
import { useStore } from '@/store/store';
import { mergeUniqueArrays } from '@/utils/merge-unique-arrays/merge-unique-arrays';

export const useInitUserContext = (userContextResponse: UserContext | null) => {
    useEffect(() => {
        if (userContextResponse) {
            const userContext = useStore.getState().userContext;

            if (userContextResponse?.favouriteGames) {
                userContext.setFavoriteGames((current) =>
                    mergeUniqueArrays(current, userContextResponse.favouriteGames || [])
                );
            }
            if (userContextResponse.accountSettings.accountID) {
                userContext.accountSettings.setAccountID(userContextResponse.accountSettings.accountID);
            }
        }
    }, [userContextResponse]);
};
